import React from 'react';
import { TextField, Typography } from "@material-ui/core";
import ReactSelect from '../../../../common/components/UI/Select/ReactSelect';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUniversity } from '@fortawesome/pro-solid-svg-icons';
import ReactInputMask from 'react-input-mask';
import InputNumber from '../../../../common/components/UI/Input/Number';
import { exists, genDatePicker } from '../../../../common/utilities/utilitiesFunctions';
import moment from 'moment';
import ActionFormAssignEmployee from './actionFormAssignEmployee';
import AddTransferJob from './AddTransferJob/addTransferJob'
import SetSkillAndCertificationProfiles from './SetSkillAndCertificationProfiles'
import DateFormatService from '../../../../WorkplanManager/services/DateFormatService';
import { UkgDateFormat } from '../../../../WorkplanManager/Enums';

export const AssignOwnersToShiftLine = (classes, employeeList, handleChangeEmployee = () => { }, handleChangeOwners = () => { }, handleChangeUpdatedReliefs = () => { }, shiftLine, action, owner) => {
    return (<ActionFormAssignEmployee
        action={action}
        shiftLine={shiftLine}
        employeeList={employeeList}
        handleChangeOwners={handleChangeOwners}
        handleChangeEmployee={handleChangeEmployee}
        handleChangeUpdatedReliefs={handleChangeUpdatedReliefs}
        owner={owner}
    />)
}

export const assignOwner = (classes, employeeList, shiftLine, handleChangeOwners = () => { }) => {
    return <div className={classes.reliefContainer}>
        <div className={classes.reliefContainerHeader}>
            <span className={classes.reliefTitle}>Owner</span>
        </div>
        <ReactSelect
            value={exists(shiftLine.owners[0]) ? { value: shiftLine.owners[0].employeeId, label: shiftLine.owners[0].employeeFullName } : ''}
            labelText={"Employee"}
            placeholder={"Select an employee"}
            options={employeeList}
            onChange={(event, value) =>
                handleChangeOwners([{ employeeId: value.value, employeeFullName: value.label, startDate: null, endDate: null }])
            }
            defaultValue={employeeList}
        />
    </div>
}

//Workplan Action Side Panel Content
export const rolloutWorkplanAction = (classes, selectedStartDate, selectedEndDate, periodLength, periodType, startOn, note, handleChangeValue = () => { }, pushCoverage, pushPlanned, t) => {
    const warningStyle= {
        color: 'red',
        border: '1px solid rgb(255, 204, 204)',
        padding: '10px',
        marginTop: '30px',
        maxWidth: '480px',
    };

    return (
        <React.Fragment>
            {genDatePicker(classes,
                selectedStartDate === null ? undefined : selectedStartDate,
                "selectedStartDate",
                handleChangeValue,
                'Effective Date',
                selectedStartDate === null,
                moment()
            )}
            {genDatePicker(classes,
                selectedEndDate === null ? undefined : selectedEndDate,
                "selectedEndDate",
                handleChangeValue,
                'End Date',
                false,
                selectedStartDate === null ? moment() : moment(selectedStartDate).add(1, 'd'),
                '3000-01-01',
                undefined,
                selectedStartDate === null, true
            )}
            <Typography className={classes.dateTypo}>
                {'Start workplan on ' + periodType.slice(0, -1).toLowerCase() + ' of the pattern'}
            </Typography>
            <InputNumber
                min={1}
                max={periodLength}
                step={1}
                precision={0}
                value={startOn}

                // error={timeValueERROR}
                strict={true}
                target='numberPattern'
                classNameContainer={classes.inputNumberContainer}
                classNameInput={classes.inputNumber}
                classLabel={classes.classLabel}
                handleChangeInput={(event) =>
                    handleChangeValue(event, "startOn")
                }
            />
            {/* <div> 
                <Checkbox color={'primary'} checked={pushCoverage} onClick={() => handleChangeValue(!pushCoverage, 'pushCoverage')} />
                Push baseline coverage to Kronos
            </div>
            <div>
                <Checkbox color={'primary'} checked={pushPlanned} onClick={() => handleChangeValue(!pushPlanned, 'pushPlanned')} />
                Push baseline planned to Kronos
            </div> */}
            <div style={warningStyle}>{t('warnings.rolloutIntegrationWarning')}</div>
        </React.Fragment >
    )
}

export const editRolloutWorkplanAction = (classes, selectedStartDate, selectedEndDate, selectedWorkPlan, handleChangeValue = () => { }, startOn) => {
    let startDate = moment(selectedStartDate).isSameOrAfter(moment()) ? moment(selectedStartDate) : moment()

    return (
        <React.Fragment>
            {genDatePicker(classes,
                selectedStartDate === null ? undefined : selectedStartDate,
                "selectedStartDate",
                handleChangeValue,
                'Effective Date',
                selectedStartDate === null,
                moment(),
                undefined,
                undefined,
                moment(selectedStartDate).isSameOrBefore(moment())
            )}
            {genDatePicker(classes,
                selectedEndDate === null ? undefined : selectedEndDate,
                "selectedEndDate",
                handleChangeValue,
                'End Date',
                false,
                startDate.add(1, 'd'),
                '3000-01-01',
                undefined,
                selectedStartDate === null || exists(selectedWorkPlan.states.find(state => state.label === 'Stopped')),
                true
            )}
            <Typography className={classes.dateTypo}>
                {'Start workplan on ' + selectedWorkPlan.periodType.slice(0, -1).toLowerCase() + ' of the pattern'}
            </Typography>
            <InputNumber
                min={1}
                max={selectedWorkPlan.periodLength}
                step={1}
                precision={0}
                isDisabled={moment(moment()).isSameOrAfter(selectedWorkPlan.startDate)}
                value={startOn}
                // error={timeValueERROR}
                strict={true}
                target='numberPattern'
                classNameContainer={classes.inputNumberContainer}
                classNameInput={classes.inputNumber}
                classLabel={classes.classLabel}
                handleChangeInput={(event) =>
                    handleChangeValue(event, "startOn")
                }
            />
        </React.Fragment>
    )
}

export const pauseWorkplanAction = (classes, selectedStartDate, selectedEndDate, selectedWorkPlan, note, handleChangeValue = () => { }, minDate, maxDate, startOn) => {
    let maxDateAux = maxDate === null || maxDate === undefined ? '' : maxDate;
    const minEndDate = getMinEndDate(selectedStartDate, maxDate);
    return (
        <React.Fragment>
            {genDatePicker(classes, selectedStartDate === null ? undefined : selectedStartDate, "selectedStartDate", handleChangeValue, 'Effective Date', selectedStartDate === null, minDate, maxDate)}
            {genDatePicker(classes, selectedEndDate === null ? undefined : selectedEndDate, "selectedEndDate", handleChangeValue, 'End Date', false, minEndDate, maxDateAux, undefined, selectedStartDate === null, true)}
        </React.Fragment>
    )
}

export const editPauseWorkplanAction = (classes, selectedStartDate, selectedEndDate, selectedWorkPlan, note, handleChangeValue = () => { }, minDate, maxDate, startOn) => {
    let maxDateAux = maxDate === null || maxDate === undefined ? '' : maxDate;
    const minEndDate = getMinEndDate(selectedStartDate, maxDate);
    return (
        <React.Fragment>
            {genDatePicker(classes, selectedStartDate === null ? undefined : selectedStartDate, "selectedStartDate", handleChangeValue, 'Effective Date', selectedStartDate === null, minDate, maxDate)}
            {genDatePicker(classes, selectedEndDate === null ? undefined : selectedEndDate, "selectedEndDate", handleChangeValue, 'End Date', false, minEndDate, maxDateAux, undefined, selectedStartDate === null, true)}
        </React.Fragment>
    )
}

export const stopWorkplanAction = (classes, selectedEndDate, note, handleChangeValue = () => { }, minDate, maxDate) => {
    return (
        <React.Fragment>
            {genDatePicker(classes, selectedEndDate === null ? undefined : selectedEndDate, "selectedEndDate", handleChangeValue, 'End Date', selectedEndDate === null, minDate, maxDate)}
        </React.Fragment>
    )
};

//ShiftLine Action Side Panel Content
export const playShiftLineAction = (classes, selectedStartDate, selectedEndDate, note, handleChangeValue = () => { }, minDate, maxDate) => {
    return (
        <React.Fragment>
            {genDatePicker(classes, selectedStartDate === null ? undefined : selectedStartDate, "selectedStartDate", handleChangeValue, 'Effective Date', selectedStartDate === null, minDate, maxDate, undefined)}
            {genDatePicker(classes, selectedEndDate === null ? undefined : selectedEndDate, "selectedEndDate", handleChangeValue, 'End Date', false, moment(selectedStartDate).add(1, 'd'), maxDate, undefined, selectedStartDate === null, true)}
        </React.Fragment>
    )
}

export const pauseShiftLineAction = (classes, selectedStartDate, selectedEndDate, note, handleChangeValue = () => { }, shiftLine, minDate, maxDate) => {
    const minEndDate = getMinEndDate(selectedStartDate, maxDate);
    return (
        <React.Fragment>
            {genDatePicker(classes, selectedStartDate === null ? undefined : selectedStartDate, "selectedStartDate", handleChangeValue, 'Effective Date', selectedStartDate === null, minDate, shiftLine.endDate, undefined)}
            {genDatePicker(classes, selectedEndDate === null ? undefined : selectedEndDate, "selectedEndDate", handleChangeValue, 'End Date', false, minEndDate, maxDate, undefined, selectedStartDate === null, true)}
        </React.Fragment >
    )
}

export const editPauseShiftLineAction = (classes, selectedStartDate, selectedEndDate, note, handleChangeValue = () => { }, shiftLine, minDate, maxDate) => {
    const minEndDate = getMinEndDate(selectedStartDate, maxDate);
    return (
        <React.Fragment>
            {genDatePicker(classes, selectedStartDate === null ? undefined : selectedStartDate, "selectedStartDate", handleChangeValue, 'Effective Date', selectedStartDate === null, minDate, shiftLine.endDate, undefined)}
            {genDatePicker(classes, selectedEndDate === null ? undefined : selectedEndDate, "selectedEndDate", handleChangeValue, 'End Date', false, minEndDate, maxDate, undefined, selectedStartDate === null, true)}
        </React.Fragment >
    )
}

export const stopShiftLineAction = (classes, selectedEndDate, handleChangeValue = () => { }, minDate, maxDate) => {
    return genDatePicker(
        classes,
        selectedEndDate === null ? undefined : selectedEndDate,
        "selectedEndDate",
        handleChangeValue,
        'End Date',
        selectedEndDate === null,
        minDate,
        maxDate
    );
}

export const editStopShiftLineAction = (classes, selectedEndDate, handleChangeValue = () => { }, minDate, maxDate) => {
    return genDatePicker(
        classes,
        selectedEndDate === null ? undefined : selectedEndDate,
        "selectedEndDate",
        handleChangeValue,
        'End Date',
        selectedEndDate === null,
        minDate,
        maxDate
    );
}

export const pauseShiftLineOwnerAction = (classes, selectedStartDate, selectedEndDate, handleChangeValue = () => { }, minDate, maxDate) => {
    return (
        <React.Fragment>
            {genDatePicker(classes,
                selectedStartDate === null ? undefined : selectedStartDate,
                "selectedStartDate",
                handleChangeValue,
                'Effective Date',
                selectedStartDate === null,
                minDate,
                maxDate
            )}
            {genDatePicker(classes,
                selectedEndDate === null ? undefined : selectedEndDate,
                "selectedEndDate",
                handleChangeValue,
                'End Date',
                false,
                selectedStartDate === null ? new Date() : moment(selectedStartDate).add(1, 'd'),
                maxDate,
                undefined,
                selectedStartDate === null,
                true
            )}
        </React.Fragment >
    )
}

export const stopShiftLineOwnerAction = (classes, selectedEndDate, handleChangeValue = () => { }, minDate, maxDate) => {
    return genDatePicker(
        classes,
        selectedEndDate === null ? undefined : selectedEndDate,
        "selectedEndDate",
        handleChangeValue,
        'End Date',
        selectedEndDate === null,
        minDate,
        maxDate
    );
}

export const createPaycodeAction = (classes, paycode = '', paycodeList, startTime, duration, handleChangeValue = () => { }) => {
    const customSingleValue = ({ data }) => (
        <div className="input-select">
            <div className="input-select__single-value">
                <FontAwesomeIcon className={classes.iconCustomSingleValue} icon={faUniversity} />
                <span>{data.label}</span>
            </div>
        </div>
    );

    return (
        <React.Fragment>
            <Typography variant="body1">
                Paycode
            </Typography>
            <ReactSelect
                placeholder={<React.Fragment><FontAwesomeIcon className={classes.iconButton} icon={faUniversity} /> Select a paycode</React.Fragment>}
                value={paycode !== '' ? paycode : ''}
                options={paycodeList}
                onChange={(event, value) => handleChangeValue(value, 'paycode')}
                target={'paycode'}
                components={{ SingleValue: customSingleValue }}
                className={classes.selectShiftLineEdit}
                error={paycode === ''}
            />
            <Typography variant="body1">
                StartTime
            </Typography>
            <TextField
                error={startTime === ''}
                required
                style={{ width: '135px' }}
                variant="outlined"
                value={startTime}
                type='time'
                format="h:mm a"
                onChange={(e) => { handleChangeValue(e.target.value, 'startTime') }}
                inputProps={{
                    step: 300
                }}>
            </TextField>
            <Typography variant="body1">
                Amount Hours
            </Typography>
            <ReactInputMask
                error={duration === ''}
                required
                style={{ width: '135px' }}
                mask="99:99"
                maskChar="0"
                value={duration}
                defaultValue={duration}
                onChange={(e) => { handleChangeValue(e.target.value, 'duration') }}
            >
                {(inputProps) => <TextField variant="outlined" {...inputProps} />}
            </ReactInputMask>
        </React.Fragment >
    );
}

export const addJobTransfer = (shift, shiftlineJob, refreshAdmin, selectedWorkPlan, shiftlineId, handleAddTransfert) => {
    const shiftStartTime = moment(shift.startDateTime);
    const shiftEndTime = moment(shift.endDateTime);
    const shiftDuration = shiftEndTime.diff(shiftStartTime, 'hours', true);
    const shiftDurationHour = `${shiftDuration.toString().split('.')[0]}`;
    const minutesMulitplier = shiftDuration % 1 !== 0 ? `0.${shiftDuration.toString().split('.')[1]}` : 0;
    const shiftDurationMinutes = Math.round(Number(minutesMulitplier) * 60);
    const shiftDurationMinutesFormatted = shiftDurationMinutes < 10 ? `0${shiftDurationMinutes}` : shiftDurationMinutes.toString();
    const shiftDurationFormatted =`${shiftDurationHour}:${shiftDurationMinutesFormatted}`;
    return (
        <>
            <Typography style={{ marginTop: 6 }}>
                <strong>
                    {DateFormatService.formatPeriod(shift.startDateTime, shift.endDateTime, UkgDateFormat.TimeFormat) + " (" + shiftDurationFormatted + ")"}
                </strong>
            </Typography>
            <Typography style={{ marginTop: 40 }}>
                <strong>
                    Segments
                </strong>
            </Typography>
            <hr></hr>

            <AddTransferJob
                shift={shift}
                shiftlineJob={shiftlineJob}
                refreshAdmin={refreshAdmin}
                selectedWorkplan={selectedWorkPlan}
                shiftlineId={shiftlineId}
                handleAddTransfert={handleAddTransfert}
            />
        </>);
}

export const setSkillAndCertificationProfiles = ({
    t,
    skillAndCertificationProfiles,
    shift,
    shiftlineJob,
    shiftSegmentsSCP,
    onValueChange,
}) => (
    <SetSkillAndCertificationProfiles
        t={t}
        skillAndCertificationProfiles={skillAndCertificationProfiles}
        shift={shift}
        shiftlineJob={shiftlineJob}
        shiftSegments={shiftSegmentsSCP}
        onValueChange={onValueChange}
    />
);

const getMinEndDate = (selectedStartDate, maxDate) => {
    let minEndDate = moment();
    if (selectedStartDate !== null) {
        minEndDate = moment(selectedStartDate).add(1, 'd')
        if (minEndDate.isAfter(moment(maxDate))) {
            minEndDate = moment(maxDate);
        }
    };
    return minEndDate;
}